import React from "react";

class DownloadIcon extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const { loading } = this.props;
    return (
      <span role='img' className='anction'>
        {
          loading
            ? <svg width="1em" height="1em" viewBox="0 0 24 24" focusable="false" fill="currentColor" pointerEvents="none">
              <circle cx="12" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="9.5, 9.4" strokeLinecap="round">
                <animateTransform attributeName="transform" type="rotate" from="0 12 10" to="360 12 10" dur="1.5s" repeatCount="indefinite" />
              </circle>
              <line x1="4" y1="22" x2="20" y2="22" stroke="currentColor" strokeWidth="2" />
              <g>
                <line x1="12" y1="5" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
                <polygon points="8.5,10 12,14.5 15.5,10" fill="currentColor" />
              </g>
            </svg>
            : <svg width="1em" height="1em" viewBox="0 0 24 24" focusable="false" fill="currentColor" pointerEvents="none">
              <polyline points="3,15 3,20.5 21,20.5 21,15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
              <g>
                <line x1="12" y1="3" x2="12" y2="14" stroke="currentColor" strokeWidth="2" />
                <polygon points="8.5,12 12,16.5 15.5,12" fill="currentColor" />
              </g>
            </svg>
        }
      </span>
    )
  }

}

export default DownloadIcon;